"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validLinearRing = exports.validPoints = exports.validPoint = exports.validNumber = void 0;
var errors_1 = require("./errors");
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function validNumber(v) {
    if (typeof v !== "number" || v - v !== 0)
        throw new errors_1.InvalidNumberError();
}
exports.validNumber = validNumber;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function validPoint(point) {
    try {
        if (!Array.isArray(point))
            throw new Error();
        if (point.length < 2)
            throw new Error();
        point.forEach(function (v) {
            validNumber(v);
        });
    }
    catch (_a) {
        throw new errors_1.InvalidPointError();
    }
}
exports.validPoint = validPoint;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function validPoints(points) {
    try {
        if (!Array.isArray(points))
            throw new Error();
        points.forEach(function (p) {
            validPoint(p);
        });
    }
    catch (_a) {
        throw new errors_1.InvalidPointsError();
    }
}
exports.validPoints = validPoints;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function validLinearRing(points) {
    try {
        validPoints(points);
        if (
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        points.length <= 3 || points[0][0] !== points[points.length - 1][0] || points[0][1] !== points[points.length - 1][1])
            throw new Error();
    }
    catch (_a) {
        throw new errors_1.InvalidLinearRingError();
    }
}
exports.validLinearRing = validLinearRing;
